import styled from '@emotion/styled';
import { SIDE_MODAL_WIDTH } from './constants';
import { SidebarSizeType } from './types';
import { MOBILE_QRY } from '~/config';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  max-height: 100vh;
  z-index: 100;
  border: 0 solid black;
  pointer-events: none;
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  background: var(--white);
  ${MOBILE_QRY} {
    background: none;
  }
`;

export const List = styled.div<{
  size: SidebarSizeType;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 100%;
  min-width: 100%;
  pointer-events: initial;
  background: var(--white);

  ${MOBILE_QRY} {
    box-shadow: 0px 32px 64px 2000px rgba(12, 16, 33, 0.14);
    min-width: ${props => SIDE_MODAL_WIDTH[props.size][0]};
    max-width: ${props => SIDE_MODAL_WIDTH[props.size][1]};
  }
`;

export const HeaderWrapper = styled.div`
  border-bottom: 1px solid var(--border1);
  height: 60px;
  padding: 0 20px;
  background: var(--white);

  ${MOBILE_QRY} {
    padding: 0 34px;
    height: 70px;
  }
`;

export const CloseWrapper = styled.div`
  height: 40px;
  width: 40px;
  min-height: 40px;
  min-width: 40px;
  max-height: 40px;
  max-width: 40px;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: var(--neut7);
  }
`;
